import type {Pointer} from '@wix/document-services-types'
import type {DmStore} from '@wix/document-manager-core'
import {getStructurePointer} from './utils/pointer'
import _ from 'lodash'
import {ReportableError} from '@wix/document-manager-utils'
import type {ConversionDalValidator} from './types'
import {ConversionDalNamespaces} from './constants'

const slottedCompLayoutValidator: ConversionDalValidator = (
    store: DmStore,
    openSnapshotStore: DmStore,
    pointer: Pointer
) => {
    if (pointer.type !== ConversionDalNamespaces.targetLayout) {
        return
    }

    const component = store.get(getStructurePointer(pointer))
    const prevValue = store.get(pointer)
    const newValue = openSnapshotStore.get(pointer)

    if (
        component?.isSlottedComponent &&
        _.isEmpty(prevValue?.containerLayout) &&
        !_.isEmpty(newValue?.containerLayout)
    ) {
        throw new ReportableError({
            errorType: 'ResponsifyAlgoDalError',
            message: 'slotted component should have empty containerLayout',
            extras: {
                slottedComponent: pointer.id
            }
        })
    }
}

const pluginCompLayoutValidator: ConversionDalValidator = (
    store: DmStore,
    openSnapshotStore: DmStore,
    pointer: Pointer
) => {
    if (pointer.type !== ConversionDalNamespaces.targetLayout) {
        return
    }

    const component = store.get(getStructurePointer(pointer))

    if (!component.parent) {
        return
    }

    const parent = store.get(getStructurePointer({id: component.parent}))
    const prevValue = store.get(pointer)
    const newValue = openSnapshotStore.get(pointer)

    if (parent?.isSlottedComponent && _.isEmpty(prevValue?.itemLayout) && !_.isEmpty(newValue?.itemLayout)) {
        throw new ReportableError({
            errorType: 'ResponsifyAlgoDalError',
            message: 'plugin component should have empty itemLayout',
            extras: {
                pluginComp: pointer.id
            }
        })
    }
}

export const validators = [slottedCompLayoutValidator, pluginCompLayoutValidator]
